import { Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { KeyboardEvent } from "react";
import { InputError, InputMessageGroup } from "components/Form";
import { useJoinMailingList, AlertMessages } from "hooks/useJoinMailingList";
import { Input, Text, Button } from "uikit";

export const SubscribeBox = () => {
  const { t } = useTranslation();
  const { mutate: handleSubmitEmail, email, alertMessage, handleEmailChange } = useJoinMailingList();

  return (
    <Flex
      bgGradient="linear(#0CE466, #04CD58)"
      px={{ base: "16px", md: "24px" }}
      py={{ base: "16px", md: "32px" }}
      maxWidth={{
        base: "328px",
        md: "512px",
      }}
      borderRadius="container"
      flexDirection="column"
      mb={8}
    >
      <Text textStyle="detail" bold textColor="gray.900" mb={2}>
        Email
      </Text>
      <Input
        value={email}
        onChange={handleEmailChange}
        height={12}
        w="100%"
        mb={alertMessage ? 2 : 4}
        placeholder={t("Your Email Address")}
        onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
          if (event.key === "Enter") {
            event.preventDefault();
            handleSubmitEmail();
          }
        }}
      />
      {alertMessage && (
        <InputMessageGroup>
          <InputError color={alertMessage === AlertMessages.SUCCESS ? "text-03" : "text-error"}>
            {t(`${alertMessage}`)}
          </InputError>
        </InputMessageGroup>
      )}
      <Button onClick={() => handleSubmitEmail()} w="80px" alignSelf="flex-end">
        Subscribe
      </Button>
    </Flex>
  );
};
